// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2W04c","colCheckbox":"styles_colCheckbox__1b6Ax"};